<template>
  <b-card no-body class="mt-6">
    <EditTag />

    <!-- add modal -->
    <modal :show.sync="editModal" header-classes="bg-primary p-3">
      <h6
        slot="header"
        class="modal-title text-white font-semibold pt-1 hide-footer"
      >
        Members Name
      </h6>
      <template>
        <div class="scroll-85vh cust-overflow-y5 mx-2">
          <div class="">
            <b-list-group flush class="overflow-x-hidden">
              <b-list-group-item
                action
                v-for="member in tempdatamodal"
                :key="'member-' + member._id"
                class="cursor-pointer py-3"
                >{{ member._user.firstname }} {{ member._user.lastname }}
              </b-list-group-item>
            </b-list-group>
          </div>
        </div>
      </template>
      <totalmembers />
      <!-- <template slot="footer">
         <base-button type="primary">SAVE CHANGES</base-button>
        <base-button type="secondary" class="ml-auto" @click="editModal = false"
          >CLOSE</base-button
        > 
      </template> -->
    </modal>
    <modal :show.sync="showModal" header-classes="bg-primary p-3">
      <h6
        slot="header"
        class="modal-title text-white font-semibold pt-1 hide-footer"
      >
        Admins Name
      </h6>
      <template>
        <div class="scroll-85vh cust-overflow-y5 mx-2">
          <div class="">
            <div
              class="overflow-x-hidden"
              v-for="member in tempadmindata"
              :key="'member-' + member._id"
            >
              <p
                v-if="member.role === 'owner' || member.role === 'admin'"
                class="cursor-pointer py-3"
              >
                {{ member._user.firstname }}
                {{ member._user.lastname }}
              </p>
            </div>
          </div>
        </div>
      </template>
      <totaladmins />
    </modal>

    <el-table
      class="table-responsive table-flush"
      header-row-class-name="thead-light table-th-color "
      :data="channel.result"
      border
    >
      <el-table-column label="Channel Photo" min-width="250px">
        <template v-slot="{ row }">
          <img class="w-28 h-28 m-auto" :src="$imageURL + '/' + row.picture" />
        </template>
      </el-table-column>
      <el-table-column
        label="Channel Name"
        min-width="250px"
        prop="channelName"
        sortable
      >
        <template v-slot="{ row }">
          <p class="font-semibold text-center name mb-0 text-sm">
            {{ row.name }}
          </p>
        </template>
      </el-table-column>

      <el-table-column label="Channel Description" min-width="250px">
        <template v-slot="{ row }">
          <p class="font-semibold text-center name mb-0 text-sm">
            {{ row.description }}
          </p>
        </template>
      </el-table-column>

      <el-table-column
        label="Total Post"
        prop="totalPost"
        min-width="130px"
        sortable
      >
        <template v-slot="{ row }">
          <p class="text-center">{{ row.postCount }}</p>
        </template>
      </el-table-column>

      <el-table-column
        label="Total Members"
        prop="totalMember"
        min-width="190px"
      >
        <template v-slot="{ row }">
          <p @click="member(row)" class="text-center">
            {{ row.memberCount }}
          </p>
        </template>
      </el-table-column>

      <el-table-column label="Admins" prop="admins" min-width="140px" sortable>
        <template v-slot="{ row }">
          <p @click="admin(row)" class="text-center">{{ row.adminCount }}</p>
        </template>
      </el-table-column>
      <el-table-column label="Status" min-width="170px" prop="status" sortable>
        <template v-slot="{ row }">
          <p class="text-center">
            <badge class="badge-dot mr-4">
              <i
                :class="`bg-${row.type == 'public' ? 'kotakblue' : 'primary'}`"
              ></i>
              <span class="status text-black">{{
                row.type.toUpperCase()
              }}</span>
            </badge>
          </p>
        </template>
      </el-table-column>
      <el-table-column
        label="Created By"
        prop="createdby"
        min-width="130px"
        sortable
      >
        <template v-slot="{ row }">
          <p class="font-semibold text-center name mb-0 text-sm">
            {{ row.createdByFullname ? row.createdByFullname : "" }}
          </p>
        </template>
      </el-table-column>
      <el-table-column
        label="Edited By"
        prop="editedby"
        min-width="130px"
        sortable
      >
        <template v-slot="{ row }">
          <p class="font-semibold text-center name mb-0 text-sm">
            {{
              row.editedByName.length != 0
                ? row.editedByName[0].firstname +
                    " " +
                    row.editedByName[0].lastname || " "
                : "-"
            }}
          </p>
        </template>
      </el-table-column>
      <el-table-column label="Plan" prop="planId" min-width="130px" sortable>
        <template v-slot="{ row }">
          <p class="font-semibold text-center name mb-0 text-sm">
            {{ row.planId.length != 0 ? row.planId[0].name : "-" }}
          </p>
        </template>
      </el-table-column>
      <el-table-column
        label="Actions"
        min-width="100px"
        class-name="text-center"
      >
        <template slot-scope="scope">
          <div class="flex justify-center items-center">
            <feather-icon
              icon="EditIcon"
              svgClasses="w-6 text-primary cursor-pointer"
              class="mr-2"
              @click="handleEdit(scope)"
            ></feather-icon>
            <feather-icon
              icon="Trash2Icon"
              svgClasses="w-6 text-red-600 cursor-pointer"
              class="ml-2"
              @click="handleDelete(scope)"
            ></feather-icon>
          </div>
        </template>
      </el-table-column>

      <!-- <el-table-column
        label="Completion"
        prop="completion"
        min-width="240px"
        sortable
      >
        <template v-slot="{ row }">
          <div class="d-flex align-items-center">
            <span class="completion mr-2">%</span>
            <div>
              <base-progress :type="row.statusType" :value="row.completion" />
            </div>
          </div>
        </template>
      </el-table-column> -->
      <!-- <el-table-column min-width="180px">
        <template v-slot="{ row }">
          <el-dropdown trigger="click" class="dropdown">
            <span class="btn btn-sm btn-icon-only text-light">
              <i class="fas fa-ellipsis-v mt-2"></i>
            </span>
            <el-dropdown-menu
              class="dropdown-menu dropdown-menu-arrow show"
              slot="dropdown"
            >
              <b-dropdown-item>Action</b-dropdown-item>
              <b-dropdown-item>Another action</b-dropdown-item>
              <b-dropdown-item>Something else here</b-dropdown-item>
            </el-dropdown-menu>
          </el-dropdown>
        </template>
      </el-table-column> -->
    </el-table>

    <b-card-footer class="py-4 d-flex justify-content-end">
      <base-pagination
        v-model="currentPage"
        @change="handlePageChange"
        :total="channel.totalCount"
        :total-rows="channel.totalCount"
      ></base-pagination>
    </b-card-footer>
  </b-card>
</template>
<script>
import projects from "./CategoryData";
import { mapState } from "vuex";
import EditTag from "./EditTagsDetail.vue";
import totalmember from "./totalmember.vue";
import totaladmin from "./totaladmin.vue";
import {
  Table,
  TableColumn,
  DropdownMenu,
  DropdownItem,
  Dropdown,
} from "element-ui";
export default {
  name: "light-table",
  components: {
    [Table.name]: Table,
    [TableColumn.name]: TableColumn,
    [Dropdown.name]: Dropdown,
    [DropdownItem.name]: DropdownItem,
    [DropdownMenu.name]: DropdownMenu,
    EditTag,
    totalmember,
    totaladmin,
  },
  data() {
    return {
      projects,
      currentPage: 1,
      // channel: [],
      total_row: 1,
      perPage: 5,
      name: "",
      editModal: false,
      showModal: false,
      tempdatamodal: [],
      tempadmindata: [],
    };
  },
  methods: {
    async member(item) {
      const result = await this.$store.dispatch("channel/GetMemberById", {
        _id: item.members,
      });
      this.tempdatamodal = result.data;
      this.editModal = true;
      // console.log(this.tempdatamodal);
    },

    async admin(item) {
      const result = await this.$store.dispatch("channel/GetMemberById", {
        _id: item.members,
      });
      this.showModal = true;
      this.tempadmindata = result.data;
      // console.log(this.tempadmindata);
    },

    async dataload() {
      // let limit = this.perPage;
      // this.$store.dispatch("admin/getUsers");
      // if ((this.currentPage - 1) * this.perPage > this.channel.length)
      //   limit = this.currentPage * this.perPage - this.channel.length;
      // const offset = this.channel.length;
      // if (
      //   !this.channel[this.currentPage * this.perPage - 1] &&
      //   this.total_row !== this.channel.length
      // ) {
      //   const result = await this.$store.dispatch("admin/getChannel", {
      //     offset: offset,
      //     limit: limit,
      //   });
      //   this.total_row = this.$store.state.admin.channel.totalCount;
      //   this.$store.state.admin.channel.result.forEach((data) => {
      //     this.channel[this.channel.length] = data;
      //   });
      //   this.channel.push();
      // }
      try {
        let payload = {
          limit: 10,
          offset: (this.currentPage - 1) * 10,
        };
        await this.$store.dispatch("admin/getChannel", payload);
        this.total_row = this.channel.totalCount;
      } catch (error) {}
    },
    async handleDelete(data) {
      const result = await this.deleteAlert();
      if (result.isConfirmed) {
        let loader = this.$loading();
        this.deleteData(data);
        loader.close();
      }
    },

    deleteAlert() {
      return this.$swal({
        title: "Please confirm your action",
        html: `<p class="text-center">Are you certain you want to proceed?<br>This action cannot be undone</p>`,
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#830c81",
        cancelButtonColor: "#d33",
        confirmButtonText: "Yes, delete it!",
      });
    },
    async deleteData({ row }) {
      const payload = {
        _id: row._id,
      };
      let loader = this.$loading();
      try {
        const data = await this.$store.dispatch("channel/DeleteChannel", {
          _id: row._id,
        });
        // if (data.code === 200) {
        //   this.$store.commit("channel/DELETE_CHANNLE", row);
        // }
        let payload = {
          limit: 10,
          offset: (this.currentPage - 1) * 10,
        };
        await this.$store.dispatch("admin/getChannel", payload);
        // this.dataload();
        loader.close();
      } catch (error) {
        loader.close();
      }
    },
    async handleEdit(scope) {
      let { row } = scope;
      this.$store.commit("UI/TOGGLE_CHANNEL_CREATE_SIDEBAR", true);
      await this.$store.commit("channel/SET_SELECTE_CHANNEL", {
        ...row,
        offset: this.currentPage,
      });
    },
    async handlePageChange(value) {
      this.currentPage = value;
      try {
        let payload = {
          limit: 10,
          offset: (this.currentPage - 1) * 10,
        };
        await this.$store.dispatch("admin/getChannel", payload);
        this.total_row = this.post.totalCount;
      } catch (error) {}
    },
  },

  computed: {
    // ...mapState("channel", ["channel"]),
    ...mapState("admin", ["channel"]),
    ...mapState("channel", {
      members: "getMemberById",
    }),
  },
  mounted() {
    this.dataload();
    // console.log(this.channel, "*************");
  },
};
</script>
